/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProcedureFeeIntegrationViewModel {
  /**
   * Procedure Code: must match a code in system maintenance (required)
   */
  procedureCode?: string | null;
  /**
   * Service date: if no date is specified, today\'s date will be used
   */
  serviceDate?: string | null;
  /**
   * Insurance Carrier Code: must match an insurance carrier in system maintenance. If no code is specified, the Procedure Fee amount from system maintenance will be used
   */
  insuranceCarrierCode?: string | null;
  /**
   * Modifier Code: must match modifier code in system maintenance. (Optional)
   */
  modifierCode?: string | null;
  /**
   * Fee Type: valid values are Procedure or Payment. Procedure will return the charge amount. Payment will return the expected payment amount. Default value is Procedure.
   */
  feeType?: string | null;
  /**
   * RESPONSE ONLY: Error message if fee cannot be found
   */
  message?: string | null;
  /**
   * RESPONSE ONLY: The fee amount for the given procedure
   */
  feeAmount?: number | null;
}
